var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { persistNSync } from 'persist-and-sync';
var initialState = {
    isInitialized: false,
    isSessionActive: false,
    isLoading: false,
    agentStatus: null,
    agentSkills: [],
    unavailableCodes: [],
    isWindowOpen: false,
    prefilledPhoneNumber: null,
    isWebRtcOwner: false,
    isAcceptingCall: false
};
export var useNicStore = create()(subscribeWithSelector(persistNSync(function (set) { return (__assign(__assign({}, initialState), { setInitialized: function (value) { return set({ isInitialized: value }); }, setSessionActive: function (value) { return set({ isSessionActive: value }); }, setLoading: function (value) { return set({ isLoading: value }); }, setAgentStatus: function (status) { return set({ agentStatus: status }); }, setAgentSkills: function (skills) { return set({ agentSkills: skills }); }, setUnavailableCodes: function (codes) { return set({ unavailableCodes: codes }); }, setWindowOpen: function (value) { return set({ isWindowOpen: value }); }, setPrefilledPhoneNumber: function (phoneNumber) {
        return set({ prefilledPhoneNumber: phoneNumber });
    }, openWindowWithPhone: function (phoneNumber) {
        return set({ isWindowOpen: true, prefilledPhoneNumber: phoneNumber });
    }, setWebRtcOwner: function (value) { return set({ isWebRtcOwner: value }); }, setAcceptingCall: function (value) { return set({ isAcceptingCall: value }); }, reset: function () { return set(initialState); } })); }, {
    name: 'nic-store',
    storage: 'localStorage',
    exclude: [/^set/, /^open/, /^reset/, 'isWebRtcOwner', 'isAcceptingCall']
})));
export var selectIsInitialized = function (state) {
    return state.isInitialized;
};
export var selectIsSessionActive = function (state) {
    return state.isSessionActive;
};
export var selectIsLoading = function (state) { return state.isLoading; };
export var selectAgentStatus = function (state) {
    return state.agentStatus;
};
export var selectAgentSkills = function (state) {
    return state.agentSkills;
};
export var selectUnavailableCodes = function (state) {
    return state.unavailableCodes;
};
export var selectIsWindowOpen = function (state) {
    return state.isWindowOpen;
};
export var selectPrefilledPhoneNumber = function (state) {
    return state.prefilledPhoneNumber;
};
export var selectIsWebRtcOwner = function (state) {
    return state.isWebRtcOwner;
};
export var selectIsAcceptingCall = function (state) {
    return state.isAcceptingCall;
};
